import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Masks } from '@core/custom-validators/masks';
import { CustomValidators } from '@core/custom-validators/validators';
import { FieldConfig } from '../../models/field-config.interface';

@Component({
  selector: 'app-form-cpf-cnpj-caepf',
  templateUrl: './form-cpf-cnpj-caepf.component.html',
  styleUrls: ['./form-cpf-cnpj-caepf.component.scss']
})
export class FormCpfCnpjCaepfComponent implements OnInit {

  formCPFCNPJCAEPF: FormGroup;
  config: FieldConfig;
  group: FormGroup;
  mask = {
    mask: Masks.cpfCnpjCaepf,
    guide: false,
    modelClean: true
  };
  firstSubmit = false;

  constructor(private formBuilder: FormBuilder) {

  }

  ngOnInit(): void {
    this.formCPFCNPJCAEPF = this.formBuilder.group({
      cpfCnpjCaepf: ['']
    })

    if (this.config.required) {
      this.cpfCnpjCaepf.setValidators(Validators.compose([Validators.required, CustomValidators.cpfCnpjCaepf]))
    }
    else
      this.cpfCnpjCaepf.setValidators(Validators.compose([CustomValidators.cpfCnpjCaepf]))

    this.group.statusChanges.subscribe((val) => {
      if (!this.firstSubmit) {
        this.firstSubmit = true;
        this.cpfCnpjCaepf.setValue(this.cpfCnpjCaepf.value);
      }
    })

    this.cpfCnpjCaepf.valueChanges.subscribe((val) => {
      if (this.cpfCnpjCaepf.valid) {
        this.control.setValue(this.clearMaskValue(val));
      }
      else {
        this.control.setValue(undefined);
      }
    })
  }

  get cpfCnpjCaepf() {
    return this.formCPFCNPJCAEPF.controls.cpfCnpjCaepf;
  }

  get control() {
    return this.group.controls[this.config.name];
  }

  clearMaskValue(val): string {
    if (val)
      return val.replace(/[^\w\s]/gi, '');

    return val;
  }

}
